import React from 'react';

import s from './FilterDivider.module.scss';

export const FilterDivider = () => {
  return <div className={s.root} />;
};
